var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  fillRule: "evenodd",
  d: "M9.618 9.551a5.382 5.382 0 1 1 10.765 0 5.382 5.382 0 0 1-10.765 0m2.205 7.277a20.2 20.2 0 0 1 6.353 0l.226.036a6.11 6.11 0 0 1 5.146 6.033 2.934 2.934 0 0 1-2.934 2.934H9.386a2.934 2.934 0 0 1-2.935-2.934 6.11 6.11 0 0 1 5.147-6.033z",
  clipRule: "evenodd"
})));
export default SvgIcoProfile;